import classNames from "classnames";
import React from "react";
import { CSS_CLASSES } from "./progress-indicator-css-classes";
import { ProgressIndicatorVariantProps } from "./progress-indicator.types";

export const ProgressIndicatorLinear: React.FC<ProgressIndicatorVariantProps> = ({
  value,
  size = "medium",
  color = "primary",
  className,
}) => {
  return (
    <div
      className={classNames(
        CSS_CLASSES.PROGRESS_INDICATOR_LINEAR_TRACK,
        {
          [CSS_CLASSES.PROGRESS_INDICATOR_LINEAR_SMALL_TRACK]: size === "small",
          [CSS_CLASSES.PROGRESS_INDICATOR_LINEAR_MEDIUM_TRACK]: size === "medium",
          [CSS_CLASSES.PROGRESS_INDICATOR_LINEAR_LARGE_TRACK]: size === "large",
          [CSS_CLASSES.PROGRESS_INDICATOR_INTERACTIVE_TRACK]: color === "interactive",
          [CSS_CLASSES.PROGRESS_INDICATOR_PRIMARY_TRACK]: color === "primary",
          [CSS_CLASSES.PROGRESS_INDICATOR_SECONDARY_TRACK]: color === "secondary",
          [CSS_CLASSES.PROGRESS_INDICATOR_ACCENT_TRACK]: color === "accent",
          [CSS_CLASSES.PROGRESS_INDICATOR_GRAY_TRACK]: color === "gray",
          [CSS_CLASSES.PROGRESS_INDICATOR_ERROR_TRACK]: color === "error",
          [CSS_CLASSES.PROGRESS_INDICATOR_WARNING_TRACK]: color === "warning",
          [CSS_CLASSES.PROGRESS_INDICATOR_SUCCESS_TRACK]: color === "success",
          [CSS_CLASSES.PROGRESS_INDICATOR_WHITE_TRACK]: color === "white",
        },
        className
      )}
    >
      <div
        className={classNames(CSS_CLASSES.PROGRESS_INDICATOR_LINEAR_BAR, {
          [CSS_CLASSES.PROGRESS_INDICATOR_LINEAR_INDETERMINATE_BAR]: value === undefined,
          [CSS_CLASSES.PROGRESS_INDICATOR_LINEAR_SMALL_BAR]: size === "small",
          [CSS_CLASSES.PROGRESS_INDICATOR_LINEAR_MEDIUM_BAR]: size === "medium",
          [CSS_CLASSES.PROGRESS_INDICATOR_LINEAR_LARGE_BAR]: size === "large",
          [CSS_CLASSES.PROGRESS_INDICATOR_INTERACTIVE_BAR]: color === "interactive",
          [CSS_CLASSES.PROGRESS_INDICATOR_PRIMARY_BAR]: color === "primary",
          [CSS_CLASSES.PROGRESS_INDICATOR_SECONDARY_BAR]: color === "secondary",
          [CSS_CLASSES.PROGRESS_INDICATOR_ACCENT_BAR]: color === "accent",
          [CSS_CLASSES.PROGRESS_INDICATOR_GRAY_BAR]: color === "gray",
          [CSS_CLASSES.PROGRESS_INDICATOR_ERROR_BAR]: color === "error",
          [CSS_CLASSES.PROGRESS_INDICATOR_WARNING_BAR]: color === "warning",
          [CSS_CLASSES.PROGRESS_INDICATOR_SUCCESS_BAR]: color === "success",
          [CSS_CLASSES.PROGRESS_INDICATOR_WHITE_BAR]: color === "white",
        })}
        style={{ transform: value === undefined ? "scaleX(1)" : `scaleX(${value / 100})` }}
      >
        {value === undefined && <div className={CSS_CLASSES.PROGRESS_INDICATOR_LINEAR_INDETERMINATE_BAR_INNER} />}
      </div>
    </div>
  );
};
